const Logo = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <p
        style={{
          margin: '0',
          fontSize: '24px',
          fontWeight: 'bold',
          fontFamily: 'Marcellus, serif',
          color: '#2b328f'
        }}
      >
        Sama
        <span style={{ color: '#ed2526' }}>
          Forecaster<sup style={{ fontSize: '12px' }}>TM</sup>
        </span>
      </p>
    </div>
  );
};

export default Logo;
